import { useState, useEffect } from 'react';
import { FaThLarge, FaBell } from 'react-icons/fa';
import Sidebar from './Sidebar';
import axios from 'axios';

const Navbar = ({ namee, mail }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [isNotificationRequested, setIsNotificationRequested] = useState(false);
  
  const getCookie = (name) => {
    if (typeof document !== 'undefined') {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
    return null;
  };

  const handlePushNoti = async (token) => {
    if (isNotificationRequested) return;
    
    try {
      const permission = await Notification.requestPermission();
      setIsNotificationRequested(true);
      
      if (permission !== 'granted') {
        // toast.info('Permission Required', 'Please allow notifications to receive alerts', 3000);
        return;
      }

      const swReg = await navigator.serviceWorker.ready;
      if (!swReg) {
        // toast.error('Service Worker Not Ready', 'Please try again later', 3000);
        return;
      }

      const subscription = await swReg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
      });

      const { data } = await axios.post("https://server.votax.co/", {
        action: "savePushNotiSub",
        authToken: token,
        subId: JSON.stringify(subscription),
      });

      if (data.status) {
        // toast.success(data.message, data.remark, 3000);
      } else {
        // toast.error(data.message, data.remark, 3000);
      }
    } catch (error) {
      console.error('Notification error:', error);
      // toast.error('Notification Failed', 'Could not enable notifications', 3000);
    }
  };

  useEffect(() => {
    const token = getCookie('authToken');
    setAuthToken(token);
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <head>
        <title>BitNova</title>
      </head>
      
      <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-left">
          <button 
            className="sidebar-toggle" 
            onClick={toggleSidebar}
            aria-label="Toggle sidebar"
          >
            <FaThLarge className="toggle-icon" />
          </button>
        </div>

        <div className="animated-text">
          <span className="color-changing-text">
            BitNova
          </span>
        </div>


      </header>

      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={toggleSidebar} 
        name={"" || "BitNova"} 
        namee={namee} 
        mail={mail}
      />
      
            <style jsx>{`
        :root {
          --primary: #8b5cf6;
          --primary-light: #c4b5fd;
          --primary-dark: #6d28d9;
          --dark: #0f172a;
          --darker: #020617;
          --light: #f8fafc;
          --lighter: #ffffff;
          --gray: #94a3b8;
          --glass: rgba(15, 23, 42, 0.8);
          --glass-border: rgba(255, 255, 255, 0.12);
        }
        
        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 64px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 24px;
          background: var(--darker);
          backdrop-filter: blur(10px);
          z-index: 1000;
          transition: all 0.3s ease;
          border-bottom: 1px solid var(--glass-border);
        }
        
        .navbar.scrolled {
          background: var(--glass);
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
        }
        
        .nav-left, .nav-right {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        
        .sidebar-toggle {
          background: none;
          border: none;
          color: var(--light);
          cursor: pointer;
          padding: 8px;
          border-radius: 8px;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .sidebar-toggle:hover {
          background: rgba(255, 255, 255, 0.1);
          transform: rotate(90deg);
        }
        
        .toggle-icon {
          font-size: 1.2rem;
        }
        
        .animated-text {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        
        .color-changing-text {
          font-size: 1.5rem;
          font-weight: 700;
          background: linear-gradient(90deg, var(--primary), var(--primary-light));
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          animation: hue-rotate 8s linear infinite;
        }
        
        @keyframes hue-rotate {
          from { filter: hue-rotate(0deg); }
          to { filter: hue-rotate(360deg); }
        }
        
        .notification-btn {
          background: none;
          border: none;
          color: var(--light);
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: all 0.3s ease;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .notification-btn:hover {
          background: rgba(255, 255, 255, 0.1);
          transform: scale(1.1);
        }
        
        .bell-icon {
          font-size: 1.2rem;
        }
        
        .notification-btn::after {
          content: '';
          position: absolute;
          top: 6px;
          right: 6px;
          width: 8px;
          height: 8px;
          background: var(--primary);
          border-radius: 50%;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .notification-btn:hover::after {
          opacity: 1;
        }
        
        @media (max-width: 768px) {
          .navbar {
            padding: 0 16px;
          }
          
          .color-changing-text {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;
